import {
  isEventModuleSlug,
  isMySpeechSlug,
  PROJECT_MODULE_SLUG_REGEX,
  RESERVED_PROJECT_MODULE_SLUGS,
} from '../../const/workspaceModuleCreate'

export function toSlug(text: string): string {
  const cyrillicToLatin: Record<string, string> = {
    а: 'a',
    б: 'b',
    в: 'v',
    г: 'g',
    д: 'd',
    е: 'e',
    ё: 'e',
    ж: 'zh',
    з: 'z',
    и: 'i',
    й: 'y',
    к: 'k',
    л: 'l',
    м: 'm',
    н: 'n',
    о: 'o',
    п: 'p',
    р: 'r',
    с: 's',
    т: 't',
    у: 'u',
    ф: 'f',
    х: 'h',
    ц: 'ts',
    ч: 'ch',
    ш: 'sh',
    щ: 'sch',
    ъ: '',
    ы: 'y',
    ь: '',
    э: 'e',
    ю: 'yu',
    я: 'ya',
  }

  let slug = ''
  let lastWasDash = false

  for (const char of text.toLowerCase()) {
    const isCyrillic = cyrillicToLatin[char]
    const latin = isCyrillic ?? char

    if (/[a-z0-9]/.test(latin)) {
      slug += latin
      lastWasDash = false
    }
    else {
      if (!lastWasDash) {
        slug += '-'
        lastWasDash = true
      }
    }
  }

  return slug.replace(/^-+|-+$/g, '')
}

function buildBaseSlugFromLabel(label: string): string {
  const trimmed = label.trim()
  if (!trimmed) {
    return ''
  }

  let base = toSlug(trimmed)
    .replace(/-/g, '_')
    .replace(/[^a-z0-9_]/g, '')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '')

  if (!base) {
    return ''
  }

  if (!/^[a-z]/.test(base)) {
    base = `m_${base}`
  }

  if (base.length > 100) {
    base = base.slice(0, 100).replace(/_+$/g, '')
  }

  return base
}

export function toSlugUniq(label: string): string {
  const ts = Date.now()
  const suffix = `_${ts}`
  const maxBaseLen = Math.max(1, 100 - suffix.length)

  let base = buildBaseSlugFromLabel(label)
  if (!base) {
    return `slug${suffix}`
  }

  if (base.length > maxBaseLen) {
    base = base.slice(0, maxBaseLen).replace(/_+$/g, '')
  }

  if (!base) {
    return `slug${suffix}`
  }

  let candidate = `${base}${suffix}`
  if (candidate.length > 100) {
    candidate = candidate.slice(0, 100).replace(/_+$/g, '')
  }

  let n = 0
  while (
    RESERVED_PROJECT_MODULE_SLUGS.has(candidate)
    || !PROJECT_MODULE_SLUG_REGEX.test(candidate)
    // Защита: пользовательский слаг не должен попадать в пространство
    // «Выступлений» (`my_speech*`), иначе новости такого модуля случайно
    // подхватит логика модерации speech на бэкенде. Префиксуем `mod_`,
    // чтобы вырваться из паттерна, и продолжаем поиск свободного варианта.
    || isMySpeechSlug(candidate)
    || isEventModuleSlug(candidate)
  ) {
    n += 1
    const extra = `_${n}`
    const baseToUse = isMySpeechSlug(base) || isEventModuleSlug(base) ? `mod_${base}` : base
    const room = 100 - suffix.length - extra.length
    const truncated = (baseToUse.slice(0, Math.max(1, room)) || 'x').replace(/_+$/g, '')
    candidate = `${truncated}${suffix}${extra}`
    if (candidate.length > 100) {
      candidate = candidate.slice(0, 100).replace(/_+$/g, '')
    }
  }

  return candidate
}
